module.exports = __webpack_public_path__ + "static/media/13.5782a477.jpg";